var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadingCase)?_c('span',{attrs:{"title":"Loading assignee"}},[_c('i',{staticClass:"far fa-fw fa-pulse fa-spinner",attrs:{"aria-hidden":"true"}})]):_c('span',[_vm._v(_vm._s(_vm.assignedToInitials || '--'))])
}
var staticRenderFns = []

export { render, staticRenderFns }